/**
 * Import Error Report component - list failed rows with errors
 */

// React not needed with new JSX transform
// import React from 'react'

interface ImportError {
  row: number
  type: 'asset' | 'sale'
  data: Record<string, string>
  errors: string[]
}

interface ImportErrorReportProps {
  errors: ImportError[]
}

export function ImportErrorReport({ errors }: ImportErrorReportProps) {
  if (errors.length === 0) return null

  return (
    <div className="bg-destructive/10 border border-destructive/50 rounded-lg p-4">
      <h4 className="font-semibold text-destructive mb-3">
        Lỗi import ({errors.length} dòng)
      </h4>
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {errors.map((error, index) => (
          <div key={index} className="bg-card rounded p-3 border border-destructive/30">
            <p className="font-semibold text-sm text-destructive mb-1">
              Dòng {error.row} ({error.type === 'asset' ? 'Tài sản' : 'Giao dịch Bán'})
            </p>
            <ul className="list-disc list-inside text-sm text-destructive mb-2">
              {error.errors.map((err, errIndex) => (
                <li key={errIndex}>{err}</li>
              ))}
            </ul>
            <details className="text-xs text-muted-foreground">
              <summary className="cursor-pointer">Xem dữ liệu</summary>
              <pre className="mt-2 p-2 bg-muted rounded overflow-auto">
                {JSON.stringify(error.data, null, 2)}
              </pre>
            </details>
          </div>
        ))}
      </div>
    </div>
  )
}

